import * as TYPES from './types';

export const submitData = dispatch => () => dispatch({ type: TYPES.SUBMIT });
export const submitSuccess = dispatch => message => dispatch({ type: TYPES.SUBMIT_SUCCESS, message });
export const submitError = dispatch => error => dispatch({ type: TYPES.SUBMIT_ERROR, error });
export const toggleConditions = dispatch => (name, checked) => dispatch({ type: TYPES.TOGGLE_CHECKBOX, name, checked });
export const setInputValue = dispatch => (name, value) => dispatch({ type: TYPES.SET_INPUT_VALUE, name, value });
